var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-container",
    { attrs: { title: _vm.$t(_vm.lblSetting.settingsAdminTitle) } },
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.roles,
                  label: "Rôles",
                  "item-text": "name",
                  "item-value": "id"
                },
                model: {
                  value: _vm.selectedRoleId,
                  callback: function($$v) {
                    _vm.selectedRoleId = $$v
                  },
                  expression: "selectedRoleId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _vm.selectedRoleId !== -1
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        color: "secondary",
                        disabled: _vm.roleAsRight
                      },
                      on: { click: _vm.openDeleteRole }
                    },
                    [_vm._v("Supprimer le role selectionné")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", color: "primary" },
                  on: { click: _vm.openCreateRole }
                },
                [_vm._v("Créer un role")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", color: "secondary" },
                  on: { click: _vm.openCreateRight }
                },
                [_vm._v("Créer un droit")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "mb-2", attrs: { "align-center": "", row: "" } },
        [
          _c("div", { staticClass: "mt-3 mr-4" }, [
            _vm._v("Rechecher un droits :")
          ]),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "append-icon": "search",
              label: "Droits",
              "single-line": "",
              "hide-details": ""
            },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedRoleId !== -1
        ? _c("h3", [_vm._v("Toutes les permission pour ce role")])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedRoleId !== -1
        ? _c(
            "v-data-table",
            {
              staticClass: "elevation-1 scroll-y",
              staticStyle: { "max-height": "50vh" },
              attrs: {
                headers: _vm.headersRoleRights,
                items: _vm.currentRoleRights,
                search: _vm.search,
                "hide-actions": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.description))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.route))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.access))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.method))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.parseDateTime(props.item.permission.createdAt)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "justify-center layout px-0" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  _vm.openEditRight(props.item)
                                }
                              }
                            },
                            [_vm._v("edit\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  _vm.openRemovePermission(props.item)
                                }
                              }
                            },
                            [_vm._v("delete\n        ")]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "no-results" },
                [
                  _c("v-flex", { attrs: { "text-xs-center": "" } }, [
                    _c("div", [_vm._v("Aucun résultat trouvé")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "no-data" },
                [
                  _c(
                    "v-alert",
                    { attrs: { value: true, color: "error", icon: "warning" } },
                    [_vm._v("\n        Aucun droit à afficher\n      ")]
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("BR"),
      _vm._v(" "),
      _vm.selectedRoleId !== -1
        ? _c("h3", [
            _vm._v(
              "Tous les autres droits de la plateforme (ne comprends pas ceux déjà dans le rôle\n    selectionné)"
            )
          ])
        : _c("h3", [_vm._v("Tous les droits")]),
      _vm._v(" "),
      _vm.allRights.length > 0
        ? _c(
            "v-data-table",
            {
              staticClass: "elevation-1 scroll-y",
              staticStyle: { "max-height": "50vh" },
              attrs: {
                headers: _vm.headersAllRights,
                items: _vm.currentRightsList,
                search: _vm.search,
                "hide-actions": "",
                dark: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.description))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.route))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.access))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(props.item.method))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-left" }, [
                        _vm._v(_vm._s(_vm.parseDateTime(props.item.createdAt)))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "justify-center layout px-0" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  _vm.openEditRight(props.item)
                                }
                              }
                            },
                            [_vm._v("edit\n        ")]
                          ),
                          _vm._v(" "),
                          _vm.selectedRoleId !== -1
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { small: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.openAttachRight(props.item)
                                    }
                                  }
                                },
                                [_vm._v("add\n        ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedRoleId === -1
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { small: "", color: "red" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDeleteRight(props.item)
                                    }
                                  }
                                },
                                [_vm._v("remove_circle\n        ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "template",
                { slot: "no-results" },
                [
                  _c("v-flex", { attrs: { "text-xs-center": "" } }, [
                    _c("div", [_vm._v("Aucun résultat trouvé")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "no-data" },
                [
                  _c(
                    "v-alert",
                    { attrs: { value: true, color: "error", icon: "warning" } },
                    [_vm._v("\n        Aucun droit à afficher\n      ")]
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-5" }, [_vm._v("Toutes les notifications")]),
      _vm._v(" "),
      _c("h4", { staticClass: "mt-3 red--text" }, [
        _vm._v(
          "Modifier le détail d'une notification le modifie pour tout les utilisateurs de la plateforme dans le profile (Paramètres de notification)"
        )
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: " red--text" }, [
        _vm._v(
          "ENGLISH : Update a notification detail will be update for all user in notification parameters from profile page"
        )
      ]),
      _vm._v(" "),
      _c("settings-child-notification", { staticClass: "mt-4" }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.editOrCreateRightDialog,
            callback: function($$v) {
              _vm.editOrCreateRightDialog = $$v
            },
            expression: "editOrCreateRightDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", {
                  staticClass: "headline",
                  domProps: { textContent: _vm._s(_vm.titleModalRight) }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nom*",
                                  rules: [
                                    function(v) {
                                      return !!v || "Nom requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.selectedRight.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedRight, "name", $$v)
                                  },
                                  expression: "selectedRight.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Description*",
                                  rules: [
                                    function(v) {
                                      return !!v || "Description requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.selectedRight.description,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedRight,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "selectedRight.description"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Route*",
                                  rules: [
                                    function(v) {
                                      return !!v || "Route requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.selectedRight.route,
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedRight, "route", $$v)
                                  },
                                  expression: "selectedRight.route"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Accès*",
                                  items: _vm.accessValues,
                                  rules: [
                                    function(v) {
                                      return !!v || "Accès requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.selectedRight.access,
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedRight, "access", $$v)
                                  },
                                  expression: "selectedRight.access"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Méthode*",
                                  items: _vm.methodValues,
                                  rules: [
                                    function(v) {
                                      return !!v || "Méthode requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.selectedRight.method,
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedRight, "method", $$v)
                                  },
                                  expression: "selectedRight.method"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("small", [_vm._v("*Champs requis")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.editOrCreateRightDialog = false
                        }
                      }
                    },
                    [_vm._v("Annuler\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        flat: "",
                        disabled: !_vm.selectedRight.isValidRight()
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.confirmRightDialog = true
                        }
                      }
                    },
                    [_vm._v("Enregistrer\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "50vw" },
          model: {
            value: _vm.confirmRightDialog,
            callback: function($$v) {
              _vm.confirmRightDialog = $$v
            },
            expression: "confirmRightDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Attention !")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("div", {
                    staticClass: "subheading",
                    domProps: {
                      textContent: _vm._s(_vm.subTitleConfirmModalRight)
                    }
                  }),
                  _vm._v(" "),
                  this.typeModalRight === "edit"
                    ? _c(
                        "div",
                        [
                          _c("br"),
                          _vm._v(" "),
                          _c("v-layout", [
                            _c("div", { staticClass: "red--text mr-1" }, [
                              _vm._v("Nom :")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.selectedRightPrevious.name
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("v-layout", [
                            _c("div", { staticClass: "red--text mr-1" }, [
                              _vm._v("Description :")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.selectedRightPrevious.description
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("v-layout", [
                            _c("div", { staticClass: "red--text mr-1" }, [
                              _vm._v("Route :")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.selectedRightPrevious.route
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("v-layout", [
                            _c("div", { staticClass: "red--text mr-1" }, [
                              _vm._v("Accès :")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.selectedRightPrevious.access
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("v-layout", [
                            _c("div", { staticClass: "red--text mr-1" }, [
                              _vm._v("Méthode :")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.selectedRightPrevious.method
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", [_vm._v("par les valeurs :")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Nom :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: { textContent: _vm._s(_vm.selectedRight.name) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Description :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        textContent: _vm._s(_vm.selectedRight.description)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Route :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: { textContent: _vm._s(_vm.selectedRight.route) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Accès :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        textContent: _vm._s(_vm.selectedRight.access)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Méthode :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        textContent: _vm._s(_vm.selectedRight.method)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "Entrez le nom du droit modifié pour valider",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.secureRightName,
                      callback: function($$v) {
                        _vm.secureRightName = $$v
                      },
                      expression: "secureRightName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.confirmRightDialog = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        flat: "",
                        disabled:
                          !(_vm.secureRightName === _vm.selectedRight.name) ||
                          _vm.loading,
                        loading: _vm.loading
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.confirmActionRight($event)
                        }
                      }
                    },
                    [_vm._v("Confirmer\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.createRoleDialog,
            callback: function($$v) {
              _vm.createRoleDialog = $$v
            },
            expression: "createRoleDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", {
                  staticClass: "headline",
                  domProps: { textContent: _vm._s("Créer un role") }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nom*",
                                  rules: [
                                    function(v) {
                                      return !!v || "Nom requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.roleToAdd.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.roleToAdd, "name", $$v)
                                  },
                                  expression: "roleToAdd.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Role*",
                                  rules: [
                                    function(v) {
                                      return !!v || "Role requis"
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.roleToAdd.role,
                                  callback: function($$v) {
                                    _vm.$set(_vm.roleToAdd, "role", $$v)
                                  },
                                  expression: "roleToAdd.role"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("small", [_vm._v("*Champs requis")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.createRoleDialog = false
                        }
                      }
                    },
                    [_vm._v("Annuler\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        flat: "",
                        disabled: !_vm.isValidRole
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.confirmRoleDialog = true
                        }
                      }
                    },
                    [_vm._v("Enregistrer\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "50vw" },
          model: {
            value: _vm.confirmRoleDialog,
            callback: function($$v) {
              _vm.confirmRoleDialog = $$v
            },
            expression: "confirmRoleDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Attention !")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("div", {
                    staticClass: "subheading",
                    domProps: {
                      textContent: _vm._s(_vm.subTitleConfirmModalRole)
                    }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Nom à afficher :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: { textContent: _vm._s(_vm.roleToAdd.name) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-layout", [
                    _c("div", { staticClass: "green--text mr-1" }, [
                      _vm._v("Valeur du role :")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: { textContent: _vm._s(_vm.roleToAdd.role) }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.confirmRoleDialog = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        flat: "",
                        disabled: _vm.loading,
                        loading: _vm.loading
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.createOrDeleteRole($event)
                        }
                      }
                    },
                    [_vm._v("Confirmer\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "50vw" },
          model: {
            value: _vm.attachOrRemoveRightToRoleDialog,
            callback: function($$v) {
              _vm.attachOrRemoveRightToRoleDialog = $$v
            },
            expression: "attachOrRemoveRightToRoleDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", {
                staticClass: "headline",
                domProps: { textContent: _vm._s(_vm.titleModalRight) }
              }),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.subTitleConfirmModalRight) + "\n        "),
                _c("div", {
                  staticClass: "green--text",
                  domProps: { textContent: _vm._s(_vm.selectedRight.name) }
                }),
                _vm._v("\n        au role\n        "),
                _c("div", {
                  staticClass: "green--text",
                  domProps: { textContent: _vm._s(_vm.roleNameSelected) }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "red--text title" }, [
                  _vm._v("Souhaitez-vous continuer ?")
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.attachOrRemoveRightToRoleDialog = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        flat: "",
                        loading: _vm.loading,
                        disabled: _vm.loading
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.addOrRemoveRightToRole($event)
                        }
                      }
                    },
                    [_vm._v("Confirmer\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ccf4a8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ccf4a8f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/settings/template.html
// module id = null
// module chunks = 